/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Contract_End_DateInputs */

const en_clients_field_contract_end_date = /** @type {(inputs: Clients_Field_Contract_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End date`)
};

const pt_br2_clients_field_contract_end_date = /** @type {(inputs: Clients_Field_Contract_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data término`)
};

/**
* | output |
* | --- |
* | "End date" |
*
* @param {Clients_Field_Contract_End_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_contract_end_date = /** @type {((inputs?: Clients_Field_Contract_End_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Contract_End_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_contract_end_date(inputs)
	return pt_br2_clients_field_contract_end_date(inputs)
});